import {useState} from 'react';
import styled from 'styled-components';

import {BorderButtonCss} from '../../_old/styled/helpers';
import {SimpleTextField} from '../../_old/TextField/SimpleTextField';
import {scToTwColour} from '../../theme';

type Props = {
  name: string;
  collection: string[];
  label: React.ReactNode;
  children?: React.ReactNode;
  removeFn: (item: string) => void;
  submitFn: (v: string) => void;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
};

export function MultiTextField(props: Props): React.JSX.Element {
  const [suggestion, setSuggestion] = useState<string>('');

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      props.submitFn(suggestion);
      setSuggestion('');
    }
  };

  const onChangeFn = (e: React.FocusEvent<HTMLInputElement>): void => {
    setSuggestion(e.target.value);
  };

  const handleBtn = (): void => {
    props.submitFn(suggestion);
    setSuggestion('');
  };

  return (
    <>
      <InputContainer>
        <SimpleTextField
          name={props.name}
          id={props.name}
          value={suggestion}
          placeholder={props.inputProps?.placeholder}
          required={props.inputProps?.required}
          onKeyPress={handleKeyPress}
          onChange={onChangeFn}
        >
          {props.label}
        </SimpleTextField>

        <button
          className="btn-secondary ml-2 min-w-fit"
          type="button"
          onClick={handleBtn}
        >
          Add
        </button>
      </InputContainer>

      <SelectedWrapper>
        {props.collection.map((item, i) => (
          <StyledRoundButton
            key={`${i}-${item}`}
            type="button"
            onClick={() => props.removeFn(item)}
          >
            {item}
          </StyledRoundButton>
        ))}

        {props.children}
      </SelectedWrapper>
    </>
  );
}

const InputContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  & > input[type='text'] {
    width: auto;
    flex: 1 1 auto;
  }
`;
const StyledRoundButton = styled.button`
  ${BorderButtonCss}

  display: inline-flex;
  align-items: center;
  margin-bottom: 0.5rem;

  &:hover,
  &:focus {
    border-color: ${scToTwColour('theme.colours.tomato8')};
  }
`;
const SelectedWrapper = styled.div`
  margin-top: 0.5em;
`;
